module.exports = __webpack_public_path__ + "img/utilityvalve_stopped.87df4e2a.svg";